module.exports = __webpack_public_path__ + "static/img/urban-887.a5cf089.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/urban-887.png
// module id = wOQX
// module chunks = 1